import { cn } from "@simpro/ui";

export interface SalonMarkProps {
  name: string;
  logoUrl: string | null;
  size?: "lg" | "md" | "sm";
}

const BOX = { lg: "size-12 text-sm md:size-14", md: "size-11 text-sm", sm: "size-9 text-xs" } as const;
const LEAF = { lg: "size-[24px]", md: "size-[22px]", sm: "size-[18px]" } as const;

/** The logo as it is, square or wide, with no frame, as tall as the header row allows. */
const LOGO_LG = "h-12 w-auto max-w-24 object-contain md:h-14 md:max-w-28";

/**
 * The salon's logo, or the Organic Wellness board's swaying sage leaf when it has none (design note
 * salon-booking-organic-wellness.md section 6 item 1). Decorative: the name beside it says whose it is.
 *
 * Large, in the header at rest, the logo is shown whole, as it is, with no frame: a logo is often a square or a
 * wide wordmark with the salon's name lettered in it, and a small circle cut its corners and shrank the
 * lettering past reading. The smaller sizes stay round, beside a name that says the rest.
 */
export function SalonMark({ logoUrl, size = "md" }: SalonMarkProps) {
  if (logoUrl) {
    return (
      <img
        src={logoUrl}
        alt=""
        className={cn(
          "shrink-0",
          size === "lg" ? LOGO_LG : cn(BOX[size], "rounded-full bg-raised object-cover ring-1 ring-edge-subtle"),
        )}
      />
    );
  }
  return (
    <span aria-hidden="true" className={cn(BOX[size], "grid shrink-0 place-items-center")}>
      <span className={cn("animate-sway block rounded-[0_100%_0_100%] bg-sage", LEAF[size])} />
    </span>
  );
}
